const ajuste_estimativa_de_matricula_reordenamento_sem_continuidade = {
  path: "/ajuste-estimativa-de-matricula-reordenamento-sem-continuidade",
  redirect: "/ajuste-estimativa-de-matricula-reordenamento-sem-continuidade",
  meta: {
    breadCrumb:
      "Planejamento de Matrícula - Ajuste Estimativa de Matrícula Reordenamento Sem Continuidade",
  },
  children: [
    {
      path: "/ajuste-estimativa-de-matricula-reordenamento-sem-continuidade",
      name: "ajuste_estimativa_de_matricula_reordenamento_sem_continuidade",
      component: () =>
        import(
          "@/views/AjusteDeEstimativaDeMatriculaReordenamentoSemContinuidade/AjusteDeEstimativaDeMatriculaReordenamentoSemContinuidade.vue"
        ),
    },
  ],
};

export { ajuste_estimativa_de_matricula_reordenamento_sem_continuidade };
